// extracted by mini-css-extract-plugin
export var arrow = "ProfileCard-module--arrow--53dcb";
export var clearDark = "ProfileCard-module--clear-dark--e3fb2";
export var content = "ProfileCard-module--content--6a917";
export var divider = "ProfileCard-module--divider--13a27";
export var grey = "ProfileCard-module--grey--2bf64";
export var links = "ProfileCard-module--links--4b000";
export var none = "ProfileCard-module--none--7cf45";
export var pink = "ProfileCard-module--pink--535b7";
export var sparkCard = "ProfileCard-module--spark-card--71f1f";
export var white = "ProfileCard-module--white--9fad7";